module.exports = __webpack_public_path__ + "img/bb4.e09e3fa9.png";